import * as yup from 'yup';

const step4Module3Schema = yup.object().shape({
  firstName: yup
    .string()
    .required()
    .matches(/^[a-zA-ZñÑáéíóúÁÉÍÓÚ ]+$/),
  lastName: yup
    .string()
    .required()
    .matches(/^[a-zA-ZñÑáéíóúÁÉÍÓÚ ]+$/),
  email: yup
    .string()
    .required()
    .email(),
  whatsapp: yup
    .string()
    .required()
    .matches(/^[0-9+]+$/),
  phone: yup
    .string()
    .required()
    .matches(/^[0-9-]+$/)
});

export { step4Module3Schema };
